import { render, staticRenderFns } from "./Pillars.vue?vue&type=template&id=3b4aafb9"
import script from "./Pillars.vue?vue&type=script&lang=js"
export * from "./Pillars.vue?vue&type=script&lang=js"
import style0 from "./Pillars.vue?vue&type=style&index=0&id=3b4aafb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports